export const CoreTextResourceSpanish: { [key: string]: any } = {
  language: 'es',
  text: {
    minutes: 'minutos',
    tile: {
      services: 'servicios',
      service: 'servicio'
    },
    loading: {
      start: 'cargando programador de citas',
      cancel: 'Esperando cancelación',
      service: 'Cargando servicios de la sucursal',
      calendar: 'Cargando horarios disponibles'
    },
    modal: {
      timeout: 'Su sesión se reiniciará en {{ countdown }} segundos.',
      navigation: 'Salir del programador de citas borrará todos los datos ingresados. ¿Continuar?',
      here: 'Sigo aquí',
      goodbye: 'adiós',
      cancel: '¿Desea cancelar esta cita?',
      yes: 'Sí',
      no: 'No'
    },
    breadcrumbs: {
      yourAppointment: 'Programar cita',
      branch: 'Programar cita',
      service: 'Programar cita - Paso {{actualStep}} de {{totalStep}}',
    },
    title: {
      branch: 'Seleccione una Ubicación',
      service: {
        1: '¿Como Podemos Ayudarle?',
        2: 'Seleccione Fecha y Hora',
        3: 'Información de Contacto',
        final: 'Su Cita'
      },
      checkIn: 'Regístrese',
      yourAppointment: {
        queue: '¡Ya está en la fila,{{firstname}}!',
        original: 'Su Cita',
        checkIn: 'Su turno está registrado, {{firstname}}!'
      }
    },
    search: {
      branch: 'Buscar ubicación',
      service: 'Buscar servicio',
    },
    noFound: {
      branch: {
        title: "No se encontraron ubicaciones",
        content: "Pruebe con una palabra clave diferente."
      },
      service: {
        title: "No se encontraron servicios",
        content: "Pruebe con una palabra clave diferente."
      }
    },
    information: {
      cancel: {
        title: 'Cita cancelada',
        content: 'Su cita ha sido cancelada.',
        button: [
          {
            title: 'Agendar una cita.',
            action: '/',
            type: 'primary'
          }
        ]
      },
      submit: {
        title: 'Se produjo un error',
        content: 'No pudimos completar su solicitud. Por favor, intente más tarde.',
        button: [
          {
            title: 'Agendar una cita.',
            action: '/',
            type: 'primary'
          }
        ]
      },
      server: {
        title: 'Programador de citas no disponible',
        content: 'El programador de citas no está disponible en este momento. Por favor, inténtelo más tarde o contacte con su sucursal para recibir asistencia.'
      },
      noavailability: {
        title: 'No hay citas disponibles',
        content: 'Por favor, seleccione un día o ubicación diferente.'
      },
      noserviceforlanguage: {
        title: 'Servicio no disponible',
        content: 'Este servicio no está disponible en esta ubicación para el idioma seleccionado. Por favor, seleccione otro idioma o ubicación para continuar.'
      },
      wrongTimeLate: {
        title: 'Registro no disponible',
        content: 'Ha llegado tarde para su cita (programada originalmente a las {{time}}). Podemos atenderle como visita sin cita o puede contactar a un agente de nuestro equipo para recibir asistencia adicional.',
        button: [
          {
            title: 'SIN CITA',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Cerrar',
            type: 'secondary',
            action: '/check-in'
          }
        ]
      },
      wrongTimeEarly: {
        title: 'Registro no disponible',
        content: 'Ha llegado demasiado temprano para su cita (programada originalmente a las {{time}}). Podemos atenderle como visita sin cita o puede contactar a un agente de nuestro equipo para recibir asistencia adicional.',
        button: [
          {
            title: 'Visita sin cita',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Cerrado',
            type: 'secondary',
            action: '/check-in'
          }
        ]
      },
      wrongDate: {
        title: 'Lo sentimos, {{firstname}}. Fecha incorrecta.',
        content: 'Parece que su cita fue programada en la sucursal de {{branch}} a las {{time}}. Podemos atenderle  como visita sin cita o puede contactar a un agente de nuestro equipo para recibir asistencia adicional.',
        button: [
          {
            title: 'SIN CITA',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Cerrar',
            type: 'secondary',
            action: '/check-in'
          }
        ]
      },
      wrongLocation: {
        title: 'Lo sentimos, {{firstname}}. Está en otra ubicación.',
        content: 'Parece que su cita estaba programada en {{branch}} a las {{time}}. Podemos atenderle como visita sin cita o pueded contactar a un agente de nuestro equipo para recibir asistencia adicional.',
        button: [
          {
            title: 'SIN CITA',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Cerrar',
            type: 'secondary',
            action: '/splash'
          }
        ]
      },
      notAvailable: {
        title: 'La hora de la cita ya no está disponible',
        content: 'La hora de la cita seleccionada ya no está disponible.',
        button: [
          {
            title: 'Programar nuevo horario',
            action: '/calendar',
            type: 'primary'
          }
        ]
      },
      expired: {
        title: 'Cita no disponible',
        content: 'La cita que solicitó ya no está disponible o no existe.',
        button: [
          {
            title: 'Agendar una cita.',
            action: '/',
            type: 'primary'
          }
        ]
      },
      session: {
        title: 'Sesión expirada',
        content: 'Por favor, escanee el código QR que aparece en el quiosco e intente de nuevo.'
      },
      wrongBranch: {
        title: 'Ubicación no disponible.',
        content: 'La ubicación ingresada no es válida o no está disponible.',
        button: [
          {
            title: 'Seleccione otra ubicación.',
            action: '/branches-location',
            type: 'primary'
          }
        ]
      },
      wrongService: {
        title: 'Servicio no disponible.',
        content: 'El servicio seleccionado no es válido o no está disponible.',
        button: [
          {
            title: 'Elija un servicio diferente',
            action: '/services/branchID',
            type: 'primary'
          }
        ]
      }
    },
    page: {
      clear: 'Borrar',
      back: 'atrás',
      checkIn: {
        body: 'Ingrese el correo electrónico o número de teléfono que usó al programar su cita.',
        banner: {
          error: {
            title: 'Error: No pudimos encontrar una cita con la información proporcionada.',
            content: 'Verifique la información e intente nuevamente, o comuníquese con un agente de nuestro equipo para recibir asistencia.'
          },
          force: {
            title: 'Error: ingrese un correo electrónico o número de teléfono válido para continuar.'
          },
          system : {
            title: 'Se produjo un error al consultar su cita.',
            content: 'Inténtelo de nuevo o comuníquese con un agente de nuestro equipo para obtener más asistencia.'
          }
        },
        form: {
          email: {
            label: 'Correo electrónico',
            placeholder: 'Ingrese correo electrónico',
            error: 'Error: Ingrese una dirección de correo electrónico válida.'
          },
          phone: {
            label: 'Número de celular',
            placeholder: 'Ingrese número de celular',
            error: 'Error: Ingrese un número de 10 dígitos.'
          },
          submit: 'Enviar'
        }
      },
      branch: {
        input: {
          search: 'Buscar ubicación'
        },
        side: {
          title: 'Encuentre su ubicación más cercana',
          content: 'Visite nuestra página de ubicaciones para encontrar una de nuestras más de 25 sucursales cercanas a usted.',
          link: 'Ubicaciones'
        }
      },
      service: {
        main: {
          input: {
            search: 'Buscar servicio'
          },
          research: 'Categorías'
        },
        side: {
          steps: ['Servicio', 'Fecha y hora', 'Información'],
          location: 'Elegir otra ubicación',
          notSelected: 'no especificado'
        }
      },
      calendar: {
        none: 'ninguno',
        morning: 'Mañana',
        afternoon: 'Tarde',
        convertTime: {
          'America/New_York': 'Hora del Este',
          'America/Chicago': 'Hora Central'
        },
        timeZone: 'Todas las horas están en (UTC-0{{hourDiff}}:00) {{timezone}} (EE. UU. y Canadá).',
        days: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        input: {
          allMember: 'Disponibilidad de los Agentes'
        },
        bannerWarning: {
          title: 'El agente solicitado no es válido o no está disponible.',
        }
      },
      splash: {
        welcome: 'Bienvenido a ',
        subText: 'Nos alegra mucho que esté aquí. Comencemos seleccionando una opción a continuación:',
        button: {
          walkin: 'SIN CITA<br>( Unirse a la fila )',
          checkin: 'REGISTRESE<br>( Tengo una cita )'
        },
        info: {
          title: 'Aviso: Alto volumen de tráfico en este momento.',
          description: 'Un agente de nuestro equipo se comunicará con usted para informarle el tiempo estimado de espera después de que se una a la fila.'
        },
        side: {
          title: 'Regístrese o únase a la fila desde su dispositivo',
          content: 'Escanee el código con su dispositivo iOS o Android.'
        }
      },
      contactInfo: {
        banner: {
          error: {
            title: 'Error: Uno o más campos son inválidos. Corrija el error para continuar.',
            content: ''
          }
        },
        form: {
          fullname: {
            label: 'Nombre completo',
            placeholder: 'Ingrese nombre completo',
            error: 'Error: Ingrese nombre y apellido.'
          },
          email: {
            label: 'Correo electrónico',
            placeholder: 'Ingrese correo electrónico',
            error: 'Error: Ingrese una dirección de correo electrónico válida.'
          },
          phone: {
            label: 'Número de celular',
            placeholder: 'Ingrese número de celular',
            error: 'Error: Ingrese un número de 10 dígitos.'
          },
          appointment: {
            label: 'Reciba notificaciones de citas por mensaje de texto',
            placeholder: 'Se pueden aplicar tarifas estándar por mensajes.',
            error: ''
          },
          membership: {
            label: 'Número de membresía (opcional)',
            placeholder: 'Ingrese número de membresía',
            error: 'Error: Ingrese su número de cuenta o membresía (máximo 10 dígitos).'
          },
          detail: {
            label: 'Detalles adicionales (opcional)',
            placeholder: 'Ingrese detalles adicionales',
            error: ''
          },
          submit: 'Enviar'
        },
        legal: `
          <div>
            Al usar el Programador en Línea de Addition Financial Credit Union, usted acepta la recopilación de su información personal, incluyendo su nombre, número de teléfono y dirección de correo electrónico. Esta información se utilizará únicamente para programar y dar seguimiento a su cita. Valoramos su privacidad y la protección de sus datos personales. Su información no se compartirá con terceros, excepto cuando lo exija la ley o sea necesario para brindarle los servicios que solicitó. Utilizamos medidas de seguridad razonables para proteger su información personal y evitar el acceso o la divulgación no autorizados. Para obtener más detalles sobre cómo recopilamos, usamos y protegemos sus datos, consulte nuestro <a href="https://pages.additionfi.com/hubfs/Disclosures/Privacy%20Notice.pdf" target="_blank" rel="noopener noreferrer" class="text-afcu-navy-800 font-semibold">Aviso de Privacidad</a>. Si tiene alguna pregunta, contáctenos directamente.
          </div>
          <div>
            Al continuar con el Programador en línea de Addition Financial, usted reconoce y acepta esta divulgación de privacidad.
          </div>
          <div>
            Esperamos darle la bienvenida a su cita. Durante la misma, le pediremos que verifique o actualice su información de contacto. Asegurarnos de que su nombre, dirección y demás datos de contacto sean correctos nos ayuda a prevenir fraudes.
          </div>
        `
      },
      yourAppointment: {
        titles: {
          location: 'Ubicación',
          service: 'Servicio',
          info: 'Información de Contacto',
          dateTime: 'Fecha & Hora',
          calendarAdd: 'Agregar a Calendario',
          cancel: 'Cancelar Cita',
          serviceDetails: 'Detalles del Servicio',
          additionalDetails: 'Detalles Adicionales',
          done: 'Finalizado',
          closing: 'La sesión se cerrará en ',
          seconds: 'segundos'
        },
        banner: {
          success: {
            title: '¡Su cita ha sido programada!'
          },
          queue: {
            success: {
              title: 'Es el número [número de posición en la fila] en la fila.'
            },
            warning: {
              title: 'Esperamos poder atenderle.',
              content: 'Tenga en cuenta que estamos experimentando tiempos de espera prolongados. Un agente de nuestro equipo le atenderá en breve.'
            },
          },
          checkin: {
            success : {
              title: 'Un agente de nuestro equipo le atenderá en breve.'
            },
            warning: {
              early: {
                title: 'Esperamos poder atenderle.',
                content: 'Le informamos que ha llegado un poco antes de lo previsto. Un agente de nuestro equipo le atenderá en breve.'
              },
              late: {
                title: 'Esperamos poder atenderle.',
                content: 'Le informamos que una llegada tardía puede retrasar la prestación de los servicios. Un agente de nuestro equipo le atenderá en breve.'
              }
            }
          }
        }
      }
    },
    footer: {
      disclaimer: 'Addition Financial Credit Union está asegurado federalmente por la Administración Nacional de Cooperativas de Crédito.',
      copyright: 'Derechos de autor &copy; 2025 Addition Financial Credit Union.'
    }
  }
}